import Details from './screens/Details';
import Faq from './screens/FAQ';
import { Kalam } from './screens/Kalam';
import Dashboard from './screens/Landing/Dashboard';
import { Revolution } from './screens/Revolution';
import Space from './screens/Space';
import { Timeline } from './screens/Timeline';
import './App.css';
import React, { useRef } from 'react';

function App() {
  const homeRef = useRef();
  const pricingRef = useRef(null);
  const pricingNewRef = useRef();
  const handleClick = () => {
    window.open(' https://rzp.io/l/NASASpaceTour');
  };
  return (
    <div className='App'>
      <Dashboard
        joinHandler={handleClick}
        divRef={homeRef}
        pricingRef={pricingRef}
      />
      <Timeline />
      <Details joinHandler={handleClick} />
      <Space joinHandler={handleClick} />
      <Kalam pricingRef={pricingNewRef} />
      <Revolution joinHandler={handleClick} />
      <Faq
        homeRef={homeRef}
        pricingRef={pricingNewRef}
        joinHandler={handleClick}
      />
    </div>
  );
}

export default App;
